var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":false,"light":false,"id":"inspire"}},[_c('v-main',{staticClass:"main-bg"},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_vm._t("default")],2)],1),_c('aa-footer'),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }